// Type
import { IdUsersStateDataItem } from 'model/dashboardUsers/dUsersReducer';
import { IdStoresStateDataItem } from 'model/dashboardStores/dStoresReducer';
import { typeRequestPagination } from 'model/system/constants';
import { typeEncashHistoryFilters, typeEncashHistoryState } from 'model/dashboardEncash/dEncashType';
import { apiClient } from 'model/axiosConfig';

export type typeEncashRequestFilters = {
    filters: {
        date?: {
            from: string | null,
            to: string | null,
        } | null,
        userId?:  IdUsersStateDataItem['id']  | null,
        storeId?:  IdStoresStateDataItem['id'] | null,
        terminalSn?: string | null,
    },
    pageFilter: typeRequestPagination,
    sortFilter: {
        direction: string,
        column: string
    }
}


// Get Encashment history list
export const getEncashHistoryList = async (payload: {
    filters: typeEncashHistoryFilters,
    sortDirection: typeEncashHistoryState['sortDirection']
    paginationRequest: typeRequestPagination
}) => {

    const path = '/product/encash/history/search'
    const config = {
        headers: {},
    }

    const data: typeEncashRequestFilters = {
        filters: {},
        pageFilter: payload.paginationRequest,
        sortFilter: {
            direction: payload.sortDirection,
            column: 'date'
        }
    }

    if (payload.filters.store) data.filters.storeId =  payload.filters.store

    if (payload.filters.user) data.filters.userId =  payload.filters.user

    if (payload.filters.terminalSn) data.filters.terminalSn =  payload.filters.terminalSn

    if (payload.filters.date) {
        data.filters.date! = payload.filters.date
    }


    try {

        return await apiClient.post(path, data, config)
    } catch (error) {
        console.log(error)
        return error.response
    }
}

